import React from 'react';
import { Button, Form } from "react-bootstrap";
const StepFour = ({ setActiveStep }) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-9">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Employment History</h5>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Employer Name:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Employer Name" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Job Title:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Job Title" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Start Date:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter Start Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>End Date:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter End Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Reason for Leaving:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Reason for Leaving" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Pre-Employment Drug Test Date:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter Pre-Employment Drug Test Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>References:</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder="Enter References" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(2)}
                                    >
                                        Previous
                                    </Button>
                                </div>
                                <div className="col-lg-4 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(4)}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepFour;
